module.exports = __webpack_public_path__ + "static/media/Image_14.4c4d1ae0.png";